export const getOrganiserInfo = (row = {}) => {
  const user = row.user || {};
  const id = user.id ?? row.user_id ?? row.organiser_id ?? '';
  const forename = user.forename ?? row.user_forename ?? '';
  const surname = user.surname ?? row.user_surname ?? '';
  const name = [forename, surname].filter(Boolean).join(' ').trim();

  return {
    id,
    name,
  };
};

/** Public organiser dashboard on ticketlab.app (optional override via VUE_APP_TICKETLAB_APP_URL). */
export const buildUserDashboardUrl = (userId) => {
  const base = (process.env.VUE_APP_TICKETLAB_APP_URL || 'https://ticketlab.app').replace(/\/$/, '');
  return `${base}/dashboard/user/${encodeURIComponent(String(userId))}`;
};

export const buildUserSearchRoute = (userId) => ({
  path: '/search',
  query: {
    searchType: 'user',
    search: String(userId),
    onlyUpcoming: false,
  },
});

export const getSearchStateFromQuery = (query = {}) => ({
  search: query.search || '',
  searchBy: query.searchType || 'ticket',
  onlyUpcoming: query.onlyUpcoming === 'true',
});
